export const SET_FICHE_TABLEAU_DATA = 'SET_FICHE_TABLEAU_DATA'
export const SET_ESPACE_FICHE = 'SET_ESPACE_FICHE'
export const SET_CURRENT_FICHE = 'SET_CURRENT_FICHE'
export const SET_CURRENT_LIGNE = 'SET_CURRENT_LIGNE'
export const SET_CURRENT_FICHE_DATA = 'SET_CURRENT_FICHE_DATA'
export const SET_LAST_FICHE = 'SET_LAST_FICHE'
export const ADD_CONTENEUR = 'ADD_CONTENEUR'
export const ADD_CONTENEUR_AFTER = 'ADD_CONTENEUR_AFTER'
export const DELETE_CONTENEUR = 'DELETE_CONTENEUR'
export const ADD_COLONNE = 'ADD_COLONNE'
export const DELETE_COLONNE = 'DELETE_COLONNE'
export const RESIZE_COLONNE = 'RESIZE_COLONNE'
export const ADD_ELEMENT = 'ADD_ELEMENT'
export const TEXT_ELEMENT_EDIT = 'TEXT_ELEMENT_EDIT'
export const DELETE_ELEMENT = 'DELETE_ELEMENT'
export const SELECTED_FICHE = 'SELECTED_FICHE'
export const IS_LOADING_FICHE_DATA = 'IS_LOADING_FICHE_DATA'
export const DROP_ELEMENT_EDIT = 'DROP_ELEMENT_EDIT'
export const SET_ADDED_TO_FICHE = 'SET_ADDED_TO_FICHE'
export const UPDATE_COLONNE_ORDER = 'UPDATE_COLONNE_ORDER'
export const UPDATE_ELEMENT_ORDER = 'UPDATE_ELEMENT_ORDER'
export const UPDATE_ELEMENT = 'UPDATE_ELEMENT'
export const TEMPLATES_FICHE = 'TEMPLATES_FICHE'
export const IS_LOADING_TEMPLATES_FICHE = 'IS_LOADING_TEMPLATES_FICHE'
export const IS_PROJECT_TEMPLATE = 'IS_PROJECT_TEMPLATE'
export const TEMPLATE_ID = 'TEMPLATE_ID'
export const IS_LOADING_FICHES = 'IS_LOADING_FICHES'
export const ACTIVE_BORDER_WIDTH = 'ACTIVE_BORDER_WIDTH'
export const ACTIVE_BORDER_COLOR = 'ACTIVE_BORDER_COLOR'
export const ADD_DROPPED_HEADER = 'ADD_DROPPED_HEADER'
export const OVERWRITE_DROPPED_HEADER = 'OVERWRITE_DROPPED_HEADER'
export const ADD_DELETED_HEADER = 'ADD_DELETED_HEADER'
export const OVERWRITE_DELETED_HEADER = 'OVERWRITE_DELETED_HEADER'
export const UPDATE_FICHE_TITLE = 'UPDATE_FICHE_TITLE'
export const UPDATE_CONTAINER = 'UPDATE_CONTAINER'
export const UPDATE_COLONNE = 'UPDATE_COLONNE'
export const UPDATE_IMAGE_SRC = 'UPDATE_IMAGE_SRC'
export const IS_LOADING_FICHE_ESPACES = 'IS_LOADING_FICHE_ESPACES'
export const TABLEAU_TEMPLATE_ID = 'TABLEAU_TEMPLATE_ID'
export const SET_ROW_ID = 'SET_ROW_ID'
export const SET_SELECTED_FICHES = 'SET_SELECTED_FICHES';



// WEBPACK FOOTER //
// ./src/store/modules/ficheEspace/mutation_types.js